/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UsersActivityOverviewResource } from './usersActivityOverviewResource';
import { UserActivityOverview200ResponseMeta } from './userActivityOverview200ResponseMeta';


export interface UserActivityOverview200Response { 
    data: UsersActivityOverviewResource;
    meta: UserActivityOverview200ResponseMeta;
}

